/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TrainingGroupDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: TrainingGroupDefinitionDto.source;
    name?: string;
    description?: string;
    trainingMainGroupDefinitionId?: string;
    order?: number;
    label?: string;
}

export namespace TrainingGroupDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
